export default {"src":"/_next/static/media/BALL.a36b1a12.svg","height":18,"width":18};